export const list = {
  table: {
    id: 'ID',
    companyId: 'Company ID',
    companyName: 'Company Name',
    createdAt: 'Create Date',
  },
  pageHeader: {
    title: 'Operators',
    titleOperatorsList: 'Personal data registration/editing',
    new: 'New',
  },
}
